import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
  selector: 'app-generic-select',
  templateUrl: './generic-select.component.html',
  styleUrls: ['./generic-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GenericSelectComponent),
      multi: true
    }]
})
export class GenericSelectComponent implements ControlValueAccessor {
  @Input() id: string;
  @Input() mensaje_error: string;
  @Input() mensaje_ayuda: string;
  @Input() options: { label: string, value: any }[] = [];
  @Input() placeholder: string = 'Selecciona una opción';
  @Output() selectionChange = new EventEmitter<any>();

  selectedValue = null;
  modelValue: string = '';
  private onChange = (value: string) => { };
  private onTouched = () => { };

  writeValue(value: string): void {
    this.modelValue = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  onInputChange(value: string): void {
    //debugger
    this.modelValue = value;
    // Notifica al ControlValueAccessor sobre el cambio de valor
    this.onChange(value);
  }

  // onValueChange(event: any) {
  //   this.selectedValue = event.target.value;
  //   this.selectionChange.emit(this.selectedValue);
  // }
}
